import { TradeIn as MtiFormTradeIn } from "@carsdotcom/mti-form/lib/types/types/TradeIn";

export interface TradeIn extends Omit<MtiFormTradeIn, "source"> {
    /**
     * AccuTrade ICO uuid
     */
    offer_uuid?: string;

    /**
     * AccuTrade ICO offer expiration
     */
    offer_expiration?: string;

    /**
     * Unless this is set to yes, the rest of the data will be ignored in calculations.
     */
    yn?: Yn;

    source?: `${Source}` | Source | MtiFormTradeIn["source"];
}

export enum Source {
    AccuTradeICO = "Accu-Trade Instant Cash Offer",
}

/**
 * Unless this is set to yes, the rest of the data will be ignored in calculations.
 */
export enum Yn {
    No = "no",
    Yes = "yes",
}
